const ARC_PATH =
	'M2 26C2 22.8483 2.62078 19.7274 3.82689 16.8156C5.03301 13.9038 6.80083 11.258 9.02944 9.02944C11.258 6.80083 13.9038 5.033 16.8156 3.82689C19.7274 2.62078 22.8483 2 26 2C29.1517 2 32.2726 2.62078 35.1844 3.82689C38.0962 5.03301 40.742 6.80083 42.9706 9.02944C45.1992 11.258 46.967 13.9038 48.1731 16.8156C49.3792 19.7274 50 22.8483 50 26'

export function ChanceGauge({ chance }: { chance: number }) {
	const clamped = Math.max(0, Math.min(100, chance))

	return (
		<div className='relative h-9 w-16 shrink-0'>
			<svg className='absolute left-1.5 top-0' width='52' height='28' viewBox='0 0 52 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<path d={ARC_PATH} className='stroke-border' strokeWidth='4' strokeLinecap='round' />
				<path d={ARC_PATH} className='stroke-success' strokeWidth='4' strokeLinecap='round' pathLength={100} strokeDasharray={`${clamped} 100`} />
			</svg>
			<div className='absolute left-3 top-[11px] w-10 text-center text-xs font-bold leading-[132%] tracking-[-0.18px] text-foreground'>{clamped}%</div>
			<div className='absolute left-[5px] top-[29px] w-[52px] text-center text-[10px] font-medium leading-3 tracking-[-0.15px] text-muted-foreground'>chance</div>
		</div>
	)
}
